<mat-dialog-content class="mat-typography">
    <h5>Are you sure to {{details.message}} ?</h5>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="handleChangeAction()">Yes</button>
    <button mat-raised-button mat-dialog-close>No</button>
</mat-dialog-actions>